export default function AlreadyPrepared() {
  const goToCta = () => {
    const el = document.getElementById('cta-final');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="bg-[#F7F6FF] py-12 md:py-20">
      <div className="mx-auto grid max-w-7xl items-center gap-8 px-4 md:grid-cols-[1.05fr_0.95fr] md:px-6">
        <div className="overflow-hidden rounded-[30px] border border-[#E4DFF6] bg-white p-2 shadow-xl shadow-[#3C3489]/10">
          <img
            src="/coverly-riesgo-prevision.png"
            alt="Metafora visual sobre la importancia de la prevision"
            className="aspect-[16/10] w-full rounded-[24px] object-cover object-center"
          />
        </div>

        <div>
          <span className="inline-flex rounded-full border border-[#DDD8F5] bg-white px-4 py-2 text-xs font-black uppercase tracking-wide text-[#534AB7]">
            Reflexion rapida
          </span>
          <h2 className="mt-5 font-title text-3xl font-black leading-tight tracking-[-0.035em] text-[#171421] md:text-5xl">
            Vivir sin prevision tambien es tentar a la suerte
          </h2>
          <p className="mt-5 text-base leading-8 text-[#625D70] md:text-lg">
            No todos los imprevistos se pueden controlar. Pero dejar a tu familia sin prevision funeraria si es una decision que puedes resolver desde hoy.
          </p>
          <button
            onClick={goToCta}
            className="mt-7 inline-flex min-h-[52px] items-center justify-center gap-2 rounded-full bg-[#534AB7] px-7 py-4 text-sm font-black text-white shadow-lg shadow-[#534AB7]/20 transition-transform hover:scale-[1.02]"
          >
            Crear mi membresia
            <i className="ri-arrow-right-line text-lg" />
          </button>
        </div>
      </div>
    </section>
  );
}
